import CandidateProjectFormDialog from "@/components/forms/candidate/add-update-project";
import { IProject } from "@/redux/features/candidateProfileSlice";

type Props =
  | {
      profileId?: never;
      project: IProject;
      projectId?: never;
      editable?: false;
      isLast?: boolean;
    }
  | {
      profileId: string;
      project: IProject;
      projectId: string;
      editable: true;
      isLast?: boolean;
    };

const Project = ({
  isLast,
  project,
  projectId,
  profileId,
  editable,
}: Props) => {
  return (
    <div
      className={`flex flex-col gap-3 items-start self-stretch py-4 ${isLast ? "" : "border-bottom-line"}`}
    >
      <div className="flex gap-3 items-center self-stretch">
        {project.imageLink ? (
          <div
            className="size-10 min-w-10 min-h-10 rounded-full"
            style={{
              backgroundImage: `url(${project.imageLink})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          />
        ) : null}
        <div className="flex flex-col gap-1 items-start flex-1">
          <p className="text-base font-semibold text-[#22234A]">
            {project.title}
          </p>
          <p className="text-xs font-medium text-[#4E4F6C] overflow-hidden text-ellipsis">
            {project.summary}
          </p>
        </div>
        {editable && (
          <CandidateProjectFormDialog
            profileId={profileId}
            projectId={projectId}
            project={project}
          />
        )}
      </div>
      <div className="flex gap-2 justify-center items-center">
        <a
          className="text-sm font-semibold tracking-[-0.14px] text-[#ED5C38] hover:text-[#ED5C38] hover:underline"
          href={project.link}
          target="_blank"
          rel="noreferrer"
        >
          View Project
        </a>
      </div>
    </div>
  );
};

export default Project;
